// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iUjl","index":"styles_index__2Kx8p"};